import Page from "webPage/Page";
import StickySection from "util/StickySection";

Page.register("page-template-initiatives-inner-observability", () => {
  new StickySection($(".js-sticky-section"));

  $("body").on("click", ".js-dropdown-btn", function () {
    $(this)
      .parents(".dropdown")
      .toggleClass("dropdown--active")
      .find(".dropdown__body")
      .stop()
      .slideToggle();
  });
});
